import { useState } from 'react';
import { AWS_S3_DOMAIN } from '~/config/constants';

export function useErrorPicture(picture) {
    const [err, setErr] = useState(false);
    const image = new Image();
    image.onerror = function () {
        setErr(true);
    };

    image.onload = function () {
        setErr(false);
    };

    if (picture) {
        image.src = (picture.includes('http') ? '' : AWS_S3_DOMAIN) + picture;
    }

    return err;
}
